// ID Numbers same as productid in database
export const MidTypes = [
    { id: 1, name: 'Gateway' },
    { id: 2, name: 'MyMoto App' },
    { id: 3, name: 'Virtual Terminal' },
    { id: 5, name: 'PDQ' }
];
